import { FREE_PRODUCT_ALLOWED_APP_NAMES } from '../constants/index';
import { window } from '../env/browser';

export const isAllowedToLoadAppName = (appName: unknown): boolean =>
  typeof appName === 'string'
    ? FREE_PRODUCT_ALLOWED_APP_NAMES.includes(appName.toLowerCase())
    : true;

export const openCelloWidget = (): void => {
  const win = window as Window;
  if (!win.cello) {
    console.warn('openCelloWidget: Cello widget is not loaded');
    return;
  }
  win.cello.cmd.push((cello) => {
    cello.open();
  });
};
